import React, { useState } from "react";
import EntityHeader from "./common/EntityHeader";
import Card from "react-bootstrap/Card";
import FieldDisplay from "./common/FieldDisplay";
import FRCPSModal from "./common/FRCPSModal";
import {
  formatDate,
  getFieldDate,
  getFieldText,
} from "../scripts/helperScripts";

function FRCPSEntity({
  clientId,
  clientProgram,
  clientIdentifiers,
  updateClientIdentifiers,
  showExpired,
  ...rest
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [clientIdentifierData, setClientIdentifierData] = useState({});

  const showModal = (clientIdentifier) => {
    const obj = {
      ccx_clientidentifiersid: clientIdentifier.ccx_clientidentifiersid,
      ccx_name: clientIdentifier.ccx_name,
      ccx_effdate: formatDate(getFieldText(clientIdentifier.ccx_effdate)),
      ccx_expdate: clientIdentifier.ccx_expdate
        ? formatDate(getFieldText(clientIdentifier.ccx_expdate))
        : "",
    };
    setClientIdentifierData(obj);
    setIsOpen(true);
  };

  const hideModal = () => {
    setIsOpen(false);
  };

  const addNew = () => {
    setClientIdentifierData({});
    setIsOpen(true);
  };
  return (
    <>
      {isOpen ? (
        <FRCPSModal
          isOpen={isOpen}
          hideModal={hideModal}
          addNew={addNew}
          clientId={clientId}
          clientProgram={clientProgram}
          initialData={clientIdentifierData}
          updateClientIdentifiers={updateClientIdentifiers}
        ></FRCPSModal>
      ) : null}
      <EntityHeader
        {...rest}
        title="FRCPS"
        add={addNew}
        clientId={clientId}
        body={clientIdentifiers.map((identifier) => (
          <div
            className={
              identifier.ccx_expdate === undefined ||
              new Date(getFieldText(identifier.ccx_expdate)) > new Date() ||
              showExpired
                ? "d-block p-2"
                : "d-none p-2"
            }
            key={identifier.ccx_clientidentifiersid}
          >
            <Card className="card-safy">
              <Card.Header
                className="p-0 ps-2 bg-safy1-1"
                style={{ color: "white" }}
              >
                <div className="row">
                  <div className="col-10 ps-4 pt-1">{identifier.ccx_name}</div>
                  <div className="col-2">
                    <i
                      className="fas fa-pen float-end p-2"
                      onClick={() => showModal(identifier)}
                    ></i>
                  </div>
                </div>
              </Card.Header>
              <Card.Body
                className={
                  identifier.ccx_expdate === undefined ||
                  new Date(getFieldDate(identifier.ccx_expdate)) > new Date()
                    ? "p-2 card-body-safy"
                    : "p-2 bg-warning"
                }
              >
                {identifier.ccx_effdate && (
                  <FieldDisplay
                    label="Effective Date"
                    value={getFieldDate(identifier.ccx_effdate)}
                  />
                )}
                {identifier.ccx_expdate && (
                  <FieldDisplay
                    label="Expiration Date"
                    value={getFieldDate(identifier.ccx_expdate)}
                  />
                )}
              </Card.Body>
            </Card>
          </div>
        ))}
      />
    </>
  );
}

export default FRCPSEntity;
